//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Tabs from './_tabs'
import Tip from './_tip'
import Guide from './_guide'
import RatePicker from './_rate_picker'
import Top from '../../_tools_base/top'
import CustomRadio from '../../_tools_base/radio'
import DefaultInput from './_default_input'
import TipDlg from '@/components/views/tip_dlg'
import PublicService from '@/service/public'

import { formatRate } from '@/utils'
import { sendCtmEvtLog } from '@/utils/log'

import log_mixin from '@/common/mixins/log'
import LoanService from '../../service'
import getRateData from '../rate/getRate'
import { getResult } from './const'
import Decimal from '../../decimal/index'

import {
    TYPES,
    defaultType,
    LOAN_TYPES,
    years,
    defaultYear,
    INTEREST_RATE_MAP,
    defaultResult,
    defaultLoanType,
    CALCS,
    CALC_TYPES,
    defaultCalcType
} from './const'

const checkInt = num => /^\d+$/.test(num)

const getCurrentDate = () => {
    const date = new Date()
    const day = date.getDate()
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ( day >= 10 ? day : '0' + day)
}
const getRate = (loanType, year) => {
    return INTEREST_RATE_MAP[loanType](year)
}

const computeLoan = (total, ratio) => {
    const _radio = (10 - (ratio * 10)) / 10
    const loan = parseInt(total * _radio / 10000) * 10000
    return loan
}

const computeDownPayment = (total, ratio) => {
    const loan = computeLoan(total, ratio)
    return ((total - loan) / 10000).toFixed(2)
}

export default {
    mixins: [
        log_mixin('房贷计算'),
        getRateData({get:LoanService.getRateData})
    ],
    props: {
        result_url: String,
        loan_rate_url: String,
        other_tools: Array,
        qr_img: String,
        bublic_tip: String,
        max_public_loan: Number,
        max_public_loan_tips: String,
    },
    data () {
        return {
            lpr: '-',
            lpr_one_year: '',
            lpr_remark: '',
            business_base_point: 0,
            total_price: '',
            type: defaultType,
            type_value: 0,
            types: TYPES,
            show_rate_picker: false,
            loan_type: defaultLoanType,
            loan_type_value: 0,

            year: defaultYear,
            year_value: years.length - 1,
            years,

            business_interest_rate: {},
            public_interest_rate: {},

            currentDate: getCurrentDate(),
            from_date: getCurrentDate(),

            loan: '',
            loan_types: [
                LOAN_TYPES.BUSINESS,
                LOAN_TYPES.PUBLIC_FUND,
                LOAN_TYPES.COMPOSE
            ],

            business_base_rate: '',
            business_multiple: 1,
            business_loan: '',

            public_base_rate: '',
            public_multiple: 1,
            public_loan: '',

            ratio_types: [
                {
                    text: '按最新LPR利率',
                    value: 'lpr'
                },
                {
                    text: '按旧版基准利率',
                    value: 'past'
                }
            ],

            ratio_type: 0,

            base_rates_opts: [],
            business_rate_show: 0,
            base_rates_opts_index: -1,
            is_custom_rate: false,

            down_payment_select: [
                {
                    text: '三成',
                    key: .3
                },
                {
                    text: '四成',
                    key: .4
                },
                {
                    text: '五成',
                    key: .5
                },
                {
                    text: '六成',
                    key: .6
                },
                {
                    text: '七成',
                    key: .7
                },
                {
                    text: '八成',
                    key: .8
                },
                {
                    text: '九成',
                    key: .9
                }
            ],
            selected_rate: .3,
            show_lpr_tip: false,
            show_busniess_base_point_tip: false,

            calcs: CALCS,
            calc_type: defaultCalcType,
            calc_type_value: 0,
            show_public_tip: false,
            total_loan: ''
        }
    },
    mounted () {
        const { total_price } = this.$route.query
        this.total_price = Number(total_price) || ''
        PublicService.getHouseLoanCalc().then(({ lpr, base_points }) => {
            this.lpr_remark = lpr.remark
            this.lpr = lpr.five_year
            this.lpr_one_year = lpr.one_year
            if (this.total_price) {
                this.calc_type_value = 0
                this.calc_type = CALCS[0].value
                this.changeDownPayment(.3)
            }
            this.getRate()
            this.getRatesConfig(base_points)
        })
    },
    computed: {
        business_loan_rate_mode() {
            return this.ratio_types[this.ratio_type].text
        },
        show_lpr () {
            return Number(this.ratio_type) === 0
        },
        down_payment () {
            return this.total_price ? computeDownPayment(this.total_price * 10000, this.selected_rate) : ''
        },
        from_date_show () {
            const from_date_arr = this.from_date.split('-')
            return from_date_arr[0] + '年' + from_date_arr[1] + '月' + from_date_arr[2] + '日'
        },
        business_rate () {
            return this.show_lpr
                ? formatRate(this.business_rate_show)
                : formatRate(this.business_base_rate * this.business_multiple)
        },
        public_rate () {
            return formatRate(this.public_base_rate * this.public_multiple)
        },
        isBusiness () {
            return this.loan_type === LOAN_TYPES.BUSINESS
        },
        isPublic () {
            return this.loan_type === LOAN_TYPES.PUBLIC_FUND
        },
        isCompose () {
            return this.loan_type === LOAN_TYPES.COMPOSE
        },
        isHousePrice() {
            return this.calc_type === CALC_TYPES.HOUSE_PRICE
        },
        calc_loan() {
            const down_payment = new Decimal(this.down_payment || 0)
            const total_price = new Decimal(this.total_price || 0)
            return total_price.sub(down_payment).toNumber()
        },
        show_rate_entry(){
            return Object.keys(this.rate_info).length > 0
        }
    },
    watch: {
        base_rates_opts_index: {
            handler (i) {
                if (this.base_rates_opts.length) {
                    const { rate, point } = this.base_rates_opts[i]
                    this.business_rate_show = rate
                    this.business_base_point = point
                }
            },
            immediate: true
        },
        calc_loan (v) {
            if (this.isBusiness) {
                this.business_loan = Number(v)
            } else if (this.isPublic) {
                this.public_loan = Number(v)
            } else if (this.isCompose) {
                this.total_loan = Number(v)
            }
        },
        total_loan () {
            this.business_loan = ''
            this.public_loan = ''
        }
    },
    methods: {
        async getRatesConfig(base_points) {
            const params = base_points.map((item) => {
                const point = new Decimal(item / 100)
                const lpr = new Decimal(this.lpr)
                let rate = point.add(lpr).toNumber()
                const rate_str = rate.toString().split(".")
                const float_part = rate_str[1] || ''
                if (!float_part || float_part.length < 2){
                    rate =  rate.toFixed(2)
                }
                return {
                    rate: Number(rate),
                    text: `${rate}%（LPR+${item}基点）`
                }
            })
            this.base_rates_opts = params
            this.base_rates_opts_index = 0
        },
        confirmCustom(rate) {
            this.is_custom_rate = true
            this.business_rate_show = rate
        },
        confirmRates() {
            this.is_custom_rate = false
        },
        toggleRatePicker() {
            this.show_rate_picker = !this.show_rate_picker
        },
        knowLoan() {
            sendCtmEvtLog('房贷计算-了解贷款利率')
        },
        toggleLprTip () {
            this.show_lpr_tip = !this.show_lpr_tip
        },
        toggleBusinessBasePointTip () {
            this.show_busniess_base_point_tip = !this.show_busniess_base_point_tip
        },
        getRate () {
            const business_interest_rate = getRate(LOAN_TYPES.BUSINESS, this.year)
            this.business_base_rate = business_interest_rate.value
            this.business_interest_rate = business_interest_rate

            const public_interest_rate = getRate(LOAN_TYPES.PUBLIC_FUND, this.year)
            this.public_base_rate = public_interest_rate.value
            this.public_interest_rate = public_interest_rate
        },
        resetCondition () {
            this.result = defaultResult
            this.year = defaultYear
            this.year_value = this.years.length - 1
            /*
            this.business_loan = ''
            this.public_loan = ''
            this.total_price = ''
            this.total_loan = ''
            this.selected_rate = 0.3
            */
        },
        changeType (e) {
            this.type_value = e.target.value
            this.type = TYPES[this.type_value]
        },
        changeRatioType (e) {
            this.ratio_type = e.target.value
        },
        changeBusinessRates(e) {
            this.business_rates_index = e.target.value
        },
        changeLoanType (type) {
            this.loan_type = type
            if (!this.total_price || !this.isHousePrice) {
                this.business_loan = ''
                this.public_loan = ''
                this.total_price = ''
                this.total_loan = ''
                this.selected_rate = 0.3
                return
            }
            switch (type) {
                case LOAN_TYPES.BUSINESS:
                    this.business_loan = this.calc_loan
                    break;
                case LOAN_TYPES.PUBLIC_FUND:
                    this.public_loan = this.calc_loan
                    break;
                case LOAN_TYPES.COMPOSE:
                    this.total_loan = this.calc_loan
                    break;
                default:
                    break;
            }
            this.resetCondition()
        },
        changeFirstDate (e) {
            const { value } = e.target
            this.from_date = value
        },
        changeYear (e) {
            const index = e.target.value
            this.year_value = index
            this.year = parseInt(this.years[index])
            this.getRate()
        },
        selectDownPayment (e) {
            const { key } = e.target.dataset
            console.log(key);
            this.changeDownPayment(key)
        },
        changeDownPayment (key) {
            this.selected_rate = key
            if (this.isCompose) {
                this.business_loan = ''
                this.public_loan = ''
            }
        },
        computeResult () {
            this.$nextTick(() => {
                let loan
                let loan_rate
                if (this.isHousePrice && !this.total_price) {
                    wx.showToast({
                        title: '请填写房屋总价',
                        icon: 'none'
                    })
                    return
                }
                if (this.isPublic || this.isCompose) {
                    if (this.max_public_loan && this.public_loan > this.max_public_loan) {
                        wx.showToast({
                            title: this.max_public_loan_tips,
                            icon: 'none'
                        })
                        return
                    }
                }
                if (this.isBusiness) {
                    loan = this.business_loan
                    loan_rate = this.business_rate
                }
                if (this.isPublic) {
                    loan = this.public_loan
                    loan_rate = this.public_rate
                }
                if (this.isCompose) {
                    const total_loan = Number(this.total_loan)
                    const business_loan = Number(this.business_loan)
                    const public_loan = Number(this.public_loan)
                    if (total_loan < business_loan && this.isHousePrice) {
                        wx.showToast({
                            title: '商贷总额超过贷款总额，请检查',
                            icon: 'none'
                        })
                        return
                    }
                    if (total_loan < public_loan && this.isHousePrice) {
                        wx.showToast({
                            title: '公积金贷款总额超过贷款总额，请检查',
                            icon: 'none'
                        })
                        return
                    }
                    loan = business_loan + public_loan
                }
                if (!loan) {
                    wx.showToast({
                        title: '请填写贷款金额',
                        icon: 'none'
                    })
                    return
                }
                if (!checkInt(loan)) {
                    wx.showToast({
                        title: '贷款金额只能整数',
                        icon: 'none'
                    })
                    return
                }
                const {
                    business_base_rate,
                    business_multiple,
                    public_base_rate,
                    public_multiple
                } = this
                const has_rate = (this.isCompose && business_base_rate && business_multiple && public_base_rate && public_multiple)
                    || (this.isBusiness && business_base_rate && business_multiple)
                    || (this.isPublic && public_base_rate && public_multiple)
                if (!has_rate) {
                    wx.showToast({
                        title: '请填写贷款利率',
                        icon: 'none'
                    })
                    return
                }
                let data = {
                    business_loan_rate_mode: this.business_loan_rate_mode,
                    public_multiple: public_multiple,
                    business_multiple: business_multiple,
                    lpr: this.lpr,
                    loan_type: this.loan_type,
                    year: parseInt(this.year),
                    type: this.type,
                    from_date: this.from_date
                }
                if (this.isCompose) {
                    data = {
                        ...data,
                        business_loan: Number(this.business_loan),
                        business_loan_rate: Number(this.business_rate),
                        public_loan: Number(this.public_loan),
                        public_loan_rate: Number(this.public_rate)
                    }
                } else {
                    data = {
                        ...data,
                        loan: Number(loan),
                        loan_rate: Number(loan_rate)
                    }
                }
                this.setHistory(data)
                wx.navigateTo({
                    url: `${this.result_url}?params=${JSON.stringify(data)}`
                })
            })
        },
        changeCalcType(e) {
            const { value, index } = e.detail
            this.calc_type_value = index
            this.calc_type = value
        },
        togglePublicTip() {
            this.show_public_tip = !this.show_public_tip
        },
        onBusinessLoanBlur(e) {
            const { value } = e.detail
            const v = Number(value)
            if (this.isCompose) {
                if (this.isHousePrice && v) {
                    const loan = this.total_loan - v
                    this.public_loan = loan < 0 ? '0' : loan
                }
            }
        },
        onPublicLoanBlur(e) {
            const { value } = e.detail
            const v = Number(value)
            if (this.isCompose) {
                if (this.isHousePrice && v) {
                    const loan = this.total_loan - v
                    this.business_loan = loan < 0 ? '0' : loan
                }
            }
        },
        setHistory(params) {
            const { public_multiple, type, lpr, loan, loan_rate,
            business_multiple, public_loan, public_loan_rate, business_loan, business_loan_rate } = params
            const { monthly_payment } = getResult(params)
            const business_params = {
                business_loan_amount: '',
                business_loan_rate: '',
                business_loan_basic_rate: '',
                business_loan_multiple: ''
            }
            const public_params = {
                fund_loan_amount: '',
                fund_loan_basic_rate: '',
                fund_loan_multiple: ''
            }
            const common_params = {
                loan_term: this.year,
                repayment_method: type.text,
                lpr: lpr,
                monthly_repayment_amount: Number(monthly_payment)
            }
            if (params.loan_type === LOAN_TYPES.PUBLIC_FUND) {
                public_params.fund_loan_amount = loan
                public_params.fund_loan_basic_rate = loan_rate
                public_params.fund_loan_multiple = public_multiple
            } else if (params.loan_type === LOAN_TYPES.BUSINESS) {
                business_params.business_loan_amount = loan
                business_params.business_loan_rate = loan_rate
                business_params.business_loan_basic_rate = loan_rate
                business_params.business_loan_multiple = business_multiple
            } else if (params.loan_type === LOAN_TYPES.COMPOSE) {
                public_params.fund_loan_multiple = public_multiple
                public_params.fund_loan_amount = public_loan
                public_params.fund_loan_basic_rate = public_loan_rate
                business_params.business_loan_amount = business_loan
                business_params.business_loan_rate = business_loan_rate
                business_params.business_loan_basic_rate = business_loan_rate
                business_params.business_loan_multiple = business_multiple
            }
            const res_params = Object.assign(business_params, public_params, common_params)
            LoanService.setLoans({...res_params})
        },
    },
    components: {
        TipDlg,
        RatePicker,
        CustomRadio,
        Top,
        Guide,
        Tabs,
        Tip,
        DefaultInput
    }
}
